module.exports = __webpack_public_path__ + "img/arrow-up-left-circle.02485187.svg";